import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // base web navegacion y a11y
    hasMainNav: true,
    openMainNav: false,
    openGobNav: false,
    hasA11yMenu: true,
    openA11yMenu: false,
    vista_simplificada: false,
    enlaces_subrayados: false,
    cambiar_tipografia: false,

    // eni
    nombre_eni: "Salud",
    // version del proyecto
    version_proyecto: process.env.PACKAGE_VERSION,
    actualizacion_proyecto: process.env.DATE_DEPLOY,
    entorno_proyecto: process.env.ENV_DEPLOY,
    // selectores de variables, seleccion inicial
    variante_seleccionada: "VTODAS",
    estado_seleccionado: "00",
    variantes_con_conteo_oms_cero: [],
    fecha_actualizacion: "06/mar/2023",
  },
  getters: {
    // base web navegacion y a11y
    hasMainNav(state) {
      return state.hasMainNav;
    },
    isOpenMainNav(state) {
      return state.openMainNav;
    },
    isOpenGobNav(state) {
      return state.openGobNav;
    },
    hasA11yMenu(state) {
      return state.hasA11yMenu;
    },
    isOpenA11yMenu(state) {
      return state.openA11yMenu;
    },
    tieneVistaSimplificada(state) {
      return state.vista_simplificada;
    },
    tieneEnlacesSubrayados(state) {
      return state.enlaces_subrayados;
    },
    cambiarTipografia(state) {
      return state.cambiar_tipografia;
    },

    // eni
    obtenerNombreEni(state) {
      return state.nombre_eni;
    },
    // version del proyecto
    versionProyecto(state) {
      return state.version_proyecto;
    },
    actualizacionProyecto(state) {
      return state.actualizacion_proyecto;
    },
    entornoProyecto(state) {
      return state.entorno_proyecto;
    },
    // selectores de variables
    varianteSeleccionada(state) {
      return state.variante_seleccionada;
    },
    estadoSeleccionado(state) {
      return state.estado_seleccionado;
    },
    variantesConConteoOmsCero(state) {
      return state.variantes_con_conteo_oms_cero;
    },
    fechaActualizacion(state) {
      return state.fecha_actualizacion;
    },
  },
  mutations: {
    // base web navegacion y a11y
    openMainNav(state) {
      state.openMainNav = true;
    },
    closeMainNav(state) {
      state.openMainNav = false;
    },
    toggleMainNav(state) {
      state.openMainNav = !state.openMainNav;
    },
    openGobNav(state) {
      state.openGobNav = true;
    },
    closeGobNav(state) {
      state.openGobNav = false;
    },
    toggleGobNav(state) {
      state.openGobNav = !state.openGobNav;
    },
    toggleA11yMenu(state) {
      state.openA11yMenu = !state.openA11yMenu;
    },
    alternarVistaSimplificada(state) {
      state.vista_simplificada = !state.vista_simplificada;
    },
    quitarVistaSimplificada(state) {
      state.vista_simplificada = false;
    },
    alternarEnlacesSubrayados(state) {
      state.enlaces_subrayados = !state.enlaces_subrayados;
    },
    quitarEnlacesSubrayados(state) {
      state.enlaces_subrayados = false;
    },
    cambiarTipografiaAtkinson(state) {
      state.cambiar_tipografia = !state.cambiar_tipografia;
    },
    quitarCambioDeTipografia(state) {
      state.cambiar_tipografia = false;
    },
    // selectores de variables, nueva seleccion
    seleccionarVariante(state, value) {
      state.variante_seleccionada = value;
    },
    seleccionarEstado(state, value) {
      state.estado_seleccionado = value;
    },
    guardarVariantesConConteoOmsCero(state, value) {
      state.variantes_con_conteo_oms_cero = value;
    },
  },
  actions: {},
  modules: {},
});
